export default __webpack_public_path__ + "static/media/smiley-face.e6989009.png";